import React from "react";
import { Heading, makeClassName, Modal, ModalProps, RequiredKeys } from "@hex-insights/core";
import { Student } from "../../../../Utilities";
import { StudentDataConsentStudentForm } from "../../../Forms";
import styles from "../Modal/styles.module.css";

export type StudentDataConsentCreateModalProps = {
	studentID: Student["id"];
} & RequiredKeys<Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">, "onClose">;

export function StudentDataConsentCreateModal({
	studentID,
	ifRef,
	onClose,
	className,
	style,
}: StudentDataConsentCreateModalProps) {
	const formStateArgs = React.useMemo(() => ({ initialFormValues: { studentID } }), [studentID]);

	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>Data Consent</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<StudentDataConsentStudentForm.ControlledCreate
					formStateArgs={formStateArgs}
					formNameSuffix={studentID}
					onSuccess={onClose}
				/>
			</Modal.Body>
		</Modal>
	);
}
